export default "__VITE_ASSET__BkxhWO4i__"